import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon, BookOpenIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
const pillar = {
  icon: BookOpenIcon,
  tag: 'Incluido 📚',
  title: 'Colección "Los 7 Objetos de Oro" (5 Tomos)',
  value: '69€',
  today: 'Hoy: Incluido',
  lead: 'Todo lo que necesitas para facturar tus primeros 500€/mes.',
  items: ['El Radar Montessori: Cómo dominar el mercado infantil que crece +18% anual en España. Torres de aprendizaje, triángulos Pikler, estanterías infantiles.', 'Decoración "Slim" & Lifestyle: Soportes de laptop minimalistas, estantes flotantes hexagonales, organizadores de escritorio premium. Se venden en 24h.', 'El Lujo en la Cocina: Tablas gourmet que transforman tus sobras de roble o nogal en 40-80€. End-grain, diseño nórdico, acabado profesional.', 'El Arte del Acabado Premium: Cómo hacer que cualquier madera parezca de revista. Aceites orgánicos, técnicas de cera, color y textura que hipnotiza.', 'Ventas de Guerrilla: Domina Wallapop e Instagram España. Scripts listos. Fotos que venden. Cómo no regatear. Cómo cerrar.']
};
export function WhatYouGet() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-228" data-mp="34wro3zm6wten">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-229" data-mp="34v6ucc7p9ehu">
        <SectionTag icon="🎁" data-id="element-230" data-mp="39w4jx9v1hatd">Lo que recibes hoy (Acceso Inmediato)</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-231" data-mp="3dxpqyekw6uvn">
          Todo lo que necesitas, en un solo lugar.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-232" data-mp="3iugbbe3qccmv">
          Todo lo que necesitas para facturar tus primeros 500€/mes.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 sm:px-6" data-id="element-233" data-mp="3sl176ts0r323">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="flex flex-col rounded-2xl border border-brown/20 bg-white p-6 shadow-card sm:p-7" data-id="element-234" data-mp="1gkw4qd50klp">
          <div className="flex items-start justify-between gap-3" data-id="element-235" data-mp="1xjfv8brqchmv">
            <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-brown/10" data-id="element-236" data-mp="1xh34pa7woyy7">
              <pillar.icon size={22} className="text-brown" data-id="element-237" data-mp="2bcfbifzc6fvh" />
            </div>
            <span className="rounded-full bg-ink/5 px-3 py-1 text-xs font-semibold text-muted" data-id="element-238" data-mp="26ikslerk24xg">
              {pillar.tag}
            </span>
          </div>
          <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-ink sm:text-xl" data-id="element-239" data-mp="2gagp4ldztmzk">
            {pillar.title}
          </h3>
          <div className="mt-2 flex items-baseline gap-2 text-sm" data-id="element-240" data-mp="2u8nfzhkiympq">
            <span className="text-muted line-through" data-id="element-241" data-mp="2q8wiyw4enacr">Valor: {pillar.value}</span>
            <span className="font-semibold text-success" data-id="element-242" data-mp="zuvzpz7ox4lb">{pillar.today}</span>
          </div>
          <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-243" data-mp="vuc2kvn4a0z6">{pillar.lead}</p>
          <ul className="mt-4 space-y-2.5" data-id="element-244" data-mp="lpvni4hgonwf">
            {pillar.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-ink/90" data-id="element-245" data-mp="ls9hea0enu2e">
                <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-246" data-mp="ptblp596iwb8" />
                <span data-id="element-247" data-mp="bxzngnvtenpk">{item}</span>
              </li>)}
          </ul>
        </m.div>
      </div>
    </section>;
}